import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useOrgan } from '../../hooks/useOrgan';
import { organizationPrimaryColors } from '../../layouts/PermanentSidebarMUI';

export const BaseDialog = ({ open, onClose, title, children, actions, maxWidth = 'md', fullWidth = true }) => {
    const { selectedOrgan } = useOrgan();

    const primaryColor = selectedOrgan?.name
        ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] || organizationPrimaryColors.ALUCOM
        : organizationPrimaryColors.ALUCOM;

    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
            <DialogTitle
                sx={{
                    backgroundColor: primaryColor,
                    color: 'white',
                    fontWeight: 'bold',
                }}
            >
                {title}
            </DialogTitle>

            <DialogContent dividers>{children}</DialogContent>

            <DialogActions>
                {actions ? (
                    actions
                ) : (
                    <Button onClick={onClose} color="primary">
                        Fechar
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
